import { useTranslations } from "@zapier/i18n";
import { Icon } from "@zapier/zinnia-icons";
import { Link, Spacer, Text } from "@zapier/design-system";
import { TEMPLATES_HELP_URL } from "@zapier/utils";

import style from "./EmptyTemplatesState.module.css";

export function NoTemplates() {
  const t = useTranslations("empty-templates-display");

  return (
    <div className={style.emptyTableDisplay}>
      <div className={style.textWrapper}>
        <div className={style.iconWrapper}>
          <Icon name="navTemplate" size="36" color="BrandOrange" />
        </div>
        <Spacer width={8} />
        <Text tag="h2" textAlign="left" type="PageHeader">
          {t("headings.no-templates")}
        </Text>
      </div>
      <Spacer height={10} />
      <div className={style.textWrapper}>
        <Text tag="p" textAlign="left" type="ParagraphHeader1">
          {t("messages.create-first-template-description")}
        </Text>
      </div>
      <Spacer height={20} />
      <div className={style.buttonWrapper}>
        <Link href={TEMPLATES_HELP_URL} variant="secondary">
          {t("actions.learn-more")}
        </Link>
      </div>
    </div>
  );
}
